<template>
  <div>
    <v-dialog 
      max-width="500px"
      transition="dialog-transition"
      persistent
      v-model="dialog"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          :color="new_color"
          width="100%"
          small
          :dark="is_dark_color"
          :light="!is_dark_color"
        >
          {{ component_map[component] }}
        </v-btn>
      </template>

      <template v-slot:default="dialog">
        <v-card>
          <v-card-title primary-title :style="{color: is_dark_color? 'white' : 'black', backgroundColor: new_color,}">
            Selecione a cor {{ component_map[component] }}
          </v-card-title>
          <v-card-text class="pb-0 mt-3">
            <div class="d-flex justify-center">
              <v-color-picker
                v-model="new_color"
                dot-size="25"
                mode="hexa"
                swatches-max-height="200"
              ></v-color-picker>

            </div>
            <!-- {{ hsla_color }} -->
            
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-alert dense type="error" class="mb-0" :value="true" v-if="is_color_light_allowed.allowed != true">
                {{ is_color_light_allowed.message }}
              </v-alert>
            
            <v-btn
              color="error"
              @click="cancelChanges()"
              text
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              @click="saveChanges()"
              text
              :disabled="is_color_light_allowed.allowed != true"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      component: {
        type: String,
        default: () => ''
      },
      color: {
        type: String,
        default: () => ''
      }
    },
    data() {
      return {
        dialog: false,
        new_color: '',
        component_map: {
          primary: 'Primária',
          secondary: 'Secundária',
          tertiary: 'Terciária',
          quarternary: 'Quaternária',
        },

        hsla_color: {
          h: null,
          s: null,
          l: null,
        },

        light_ranges_allowed: {
          primary: (val) => val <= 35 || 'Deve ser uma cor escura', 
          secondary: (val) => (val > 35 && val < 90) || 'Não deve ser uma cor tão escura nem tão clara', 
          tertiary: (val) => (val > 35 && val < 90) || 'Não deve ser uma cor tão escura nem tão clara', 
          quarternary: (val) => val > 90 || 'Deve ser uma cor muito clara',
        }
      }
    },
    mounted () {
      this.setNewColor();
    },
    methods: {
      saveChanges() {
        this.$emit('updated', this.new_color, this.component);
        this.dialog = false;
      },
      cancelChanges() {
        this.new_color = this.color;
        this.dialog = false;
      },
      setNewColor() {
        this.new_color = this.color;
      },
      get_hsla_color() {
        var c = this.new_color.substring(1);      // strip #
        var rgb = parseInt(c, 16);   // convert rrggbb to decimal
        var r = (rgb >> 16) & 0xff;  // extract red
        var g = (rgb >>  8) & 0xff;  // extract green
        var b = (rgb >>  0) & 0xff;  // extract blue

        r /= 255, g /= 255, b /= 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) {
          h = s = 0; // achromatic
        } else {
          var d = max - min;
          s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
          switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
          }
          h /= 6;
        }
        
        h = Math.round(h * 360);
        s = Math.round(s * 100);
        l = Math.round(l * 100);

        this.hsla_color.h = h
        this.hsla_color.s = s
        this.hsla_color.l = l
      },
    },
    computed: {
      is_color_light_allowed(){
        const evaluation = this.light_ranges_allowed[this.component](this.hsla_color.l)
        return {
          allowed: evaluation == true,
          message: evaluation
        }
      },
      is_dark_color() {
        var c = this.new_color.substring(1);      // strip #
        var rgb = parseInt(c, 16);   // convert rrggbb to decimal
        var r = (rgb >> 16) & 0xff;  // extract red
        var g = (rgb >>  8) & 0xff;  // extract green
        var b = (rgb >>  0) & 0xff;  // extract blue

        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
        this.get_hsla_color()

        if (luma > 128) {
          return false;
        } else {
          return true;
        }
      },
    },
    watch: {
      color(nv, ov) {
        this.setNewColor();
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>